import * as requestApi from './api'

let allApi = Object.assign(
    requestApi
);

export default allApi;



// WEBPACK FOOTER //
// ./src/api/index.js